<template>
  <div class="form-item__container">
    <div class="form-item__left-col">
      <span class="form-item__label">{{ config.label }}</span>
    </div>
    <div class="form-item__right-col">
      <el-date-picker v-model="$$FormData[config.__key]" type="daterange" align="center" size="mini" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :editable="false" :default-time="['00:00:00', '23:59:59']">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePicker'
}
</script>

<style lang="scss" scoped>
.el-date-editor {
  width: auto;
}
</style>